<template>
  <b-modal
    :ref="modal_name"
    hide-footer
    centered
    hide-header-close
    class="p-2 d-block"
    title="Reporte Consolidado Permisos Sindicales"
  >
    <div class="col-12 d-flex my-5">
      <!--      <div v-if="loading" id="loader"></div>-->
      <div class="col-6 text-center">
        <label>Desde:</label>
        <b-form-datepicker v-model="start_date" :max="max_date" class="mb-2" />
      </div>
      <div class="col-6 text-center">
        <label>Hasta:</label>
        <b-form-datepicker
          :disabled="!Boolean(start_date !== '')"
          v-model="end_date"
          :min="start_date"
          :max="max_date"
          class="mb-2"
        />
      </div>
    </div>
    <div v-if="loading" class="mx-auto my-5" id="loaderReport"></div>
    <div v-if="!loading" class="text-center">
      <button
        v-if="(start_date !== '') & (end_date !== '')"
        class="btn btn-success p-3 my-5"
        @click="getRequestsToExcel"
      >
        Consolidar Reporte
      </button>
      <b-button class="mt-3" variant="outline-danger" block @click="close">
        Cerrar
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import serverConfig from "@/services/config";
import { mapState } from "vuex";
// import AxiosPermisos from "@/services/axiosPermisos";
// import XLSX from "xlsx";

export default {
  name: "Modal",
  data: () => ({
    serverPath: serverConfig.permisosURL,
    start_date: "",
    end_date: "",
    loading: false,
  }),
  computed: {
    ...mapState("modCore", ["user"]),
    /**
     * Nombre de la modal
     **/
    modal_name() {
      return "modal-all-demands";
    },
    /**
     * Fecha maxima para el calendario
     **/
    max_date() {
      return this.get_year + "-" + (this.get_mont + 3) + "-" + this.get_day;
    },
  },
  methods: {
    /**
     * Abirir la modal
     **/
    show() {
      this.showModal(this.modal_name);
    },
    /**
     * Cerrar la modal y limpiar los campos
     **/
    close() {
      this.hideModal(this.modal_name);
      this.start_date = "";
      this.end_date = "";
      this.loading = false;
    },

    async getRequestsToExcel() {
      const me = this;
      const parameters = {
        start_date: me.start_date,
        end_date: me.end_date,
        user_id: me.user.id,
      };
      me.generarReport(parameters);
    },
    generarReport(parameters) {
      let link = `${process.env.VUE_APP_URL_API}/v1/LicensesByBpExport/${parameters?.user_id}/${parameters?.start_date}/${parameters?.end_date}`;

      const a = document.createElement("a");
      a.href = link;
      a.target = "_blank";
      a.click();
    },
  },
};
</script>

<style scoped>
#loaderReport {
  left: 50%;
  top: 50%;
  z-index: 1;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}
</style>
